import { render, staticRenderFns } from "./siasn.vue?vue&type=template&id=2905c872"
import script from "./siasn.vue?vue&type=script&lang=js"
export * from "./siasn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports